import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'
import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'

export default {
  SET_ITEMS(state, payload) {
    state.items = [...state.items, ...payload.mass_payments]
    state.total = payload.total || 100
  },
  SET_SEARCH(state, payload) {
    state.search = payload
  },

  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ACTION_LOADING(state, payload) {
    state.actionLoading = payload
  },
  SET_SORT(state, payload) {
    state.sort = payload
  },
  SET_PAGE(state, payload) {
    state.page = payload
  },
  RESET_PAGE(state) {
    state.items = []
    state.page = 1
    state.total = 10
  },
  RESET_SEARCH(state) {
    state.search = null
  },
  RESET_STORE(state, { resetSort = true } = {}) {
    state.items = []
    state.page = 1
    state.total = 10

    if (resetSort) {
      state.sort = {
        sort_by: SORT_ORDER.PAID_SUM,
        sort_direction: SORT_DIRECTION.ASC,
      }
    }
  },
  SET_TERMS_ACCEPTED(state, payload) {
    state.terms_accepted = payload
  },
}
